import { useTranslation } from "react-i18next";
import { AISummary, useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface AISummaryCardProps {
  content: string;
  date?: Date;
}

export const AISummaryCard = ({ content, date }: AISummaryCardProps) => {
  const { t } = useTranslation("contacts");
  const { format } = useDateFnsFormattersWithLocale();

  return (
    <AISummary
      title={t("Interaction Summary")}
      content={content}
      date={date ? format(date, "MMM d, yyyy") : undefined}
    />
  );
};
